export default [
  {
    path: "/report/turnovertable",
    name: "turnovertable",
    component: () => import("@/views/report/turnovertable/index.vue"),
    meta: {
      pageTitle: "TurnOverTable",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "TurnOverTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/GetFilteredByUserList",
    name: "turnovertableuser",
    component: () => import("@/views/report/turnovertable/indexUser.vue"),
    meta: {
      pageTitle: "TurnOverTableUser",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "TurnOverTableUser",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form171",
    name: "form171",
    component: () => import("@/views/report/form171/index.vue"),
    meta: {
      pageTitle: "Form171",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form171",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form120",
    name: "form120",
    component: () => import("@/views/report/form120/index.vue"),
    meta: {
      pageTitle: "Form120",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form120",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form120v",
    name: "form120v",
    component: () => import("@/views/report/form120v/index.vue"),
    meta: {
      pageTitle: "Form120V",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form120V",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form121",
    name: "form121",
    component: () => import("@/views/report/form121/index.vue"),
    meta: {
      pageTitle: "Form121",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form121",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form121v",
    name: "form121v",
    component: () => import("@/views/report/form121v/index.vue"),
    meta: {
      pageTitle: "Form121V",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form121V",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form123",
    name: "form123",
    component: () => import("@/views/report/form123/index.vue"),
    meta: {
      pageTitle: "Form123",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form123",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form155",
    name: "form155",
    component: () => import("@/views/report/form155/index.vue"),
    meta: {
      pageTitle: "Form155",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form155",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form155v",
    name: "form155v",
    component: () => import("@/views/report/form155v/index.vue"),
    meta: {
      pageTitle: "Form155V",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form155V",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form141a",
    name: "form141a",
    component: () => import("@/views/report/form141a/index.vue"),
    meta: {
      pageTitle: "Form141a",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form141a",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form121a",
    name: "form121a",
    component: () => import("@/views/report/form121a/index.vue"),
    meta: {
      pageTitle: "Form121a",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form121a",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form175",
    name: "form175",
    component: () => import("@/views/report/form175/index.vue"),
    meta: {
      pageTitle: "Form175",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form175",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/application22",
    name: "application22",
    component: () => import("@/views/report/application22/index.vue"),
    meta: {
      pageTitle: "Application22",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Application22",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form19",
    name: "form19",
    component: () => import("@/views/report/form19/index.vue"),
    meta: {
      pageTitle: "Form19",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form19",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form18",
    name: "form18",
    component: () => import("@/views/report/form18/index.vue"),
    meta: {
      pageTitle: "Form18",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form18",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/currencyreport",
    name: "currencyreport",
    component: () => import("@/views/report/currencyreport/index.vue"),
    meta: {
      pageTitle: "CurrencyReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "CurrencyReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/currencyinoutreport",
    name: "currencyinoutreport",
    component: () => import("@/views/report/currencyinoutreport/index.vue"),
    meta: {
      pageTitle: "CurrencyInOutReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "CurrencyInOutReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/requirementreport",
    name: "requirementreport",
    component: () => import("@/views/report/requirementreport/index.vue"),
    meta: {
      pageTitle: "RequirementReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "RequirementReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/atmturnover/id=:id",
    name: "atmturnover",
    component: () => import("@/views/report/atmturnover/index1.vue"),
    meta: {
      pageTitle: "AtmTurnover",
      navActiveLink: "getpresentlist",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmTurnover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/atmturnover/view/id=:id",
    name: "ViewAtmTurnover",
    component: () => import("@/views/report/atmturnover/view.vue"),
    meta: {
      pageTitle: "AtmTurnover",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmTurnover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/atmturnover/getpresentlist",
    name: "getpresentlist",
    component: () => import("@/views/report/atmturnover/index.vue"),
    meta: {
      pageTitle: "AtmTurnover",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AtmTurnover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/iabsdailyrest",
    name: "iabsdailyrest",
    component: () => import("@/views/report/iabsdailyrest/index.vue"),
    meta: {
      pageTitle: "IabsDailyRest",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "IabsDailyRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/iabsoffbalancedailyrest",
    name: "iabsoffbalancedailyrest",
    component: () => import("@/views/report/iabsoffbalancedailyrest/index.vue"),
    meta: {
      pageTitle: "IabsOffBalanceDailyRest",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "IabsOffBalanceDailyRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/offbalancerestbyuserreport",
    name: "offbalancerestbyuserreport",
    component: () =>
      import("@/views/report/offbalancerestbyuserreport/index.vue"),
    meta: {
      pageTitle: "OffBalanceRestByUserReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "OffBalanceRestByUserReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/offbalancerequirementreport",
    name: "offbalancerequirementreport",
    component: () =>
      import("@/views/report/offbalancerequirementreport/index.vue"),
    meta: {
      pageTitle: "OffBalanceRequirementReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "OffBalanceRequirementReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/offbalancereport",
    name: "offbalancereport",
    component: () => import("@/views/report/offbalancereport/index.vue"),
    meta: {
      pageTitle: "OffBalanceReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "OffBalanceReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/offbalancereport/view/id=:id",
    name: "viewoffbalancereport",
    component: () => import("@/views/report/offbalancereport/view.vue"),
    meta: {
      pageTitle: "OffBalanceReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "OffBalanceReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/restreport",
    name: "restreport",
    component: () => import("@/views/report/restreport/index.vue"),
    meta: {
      pageTitle: "RestReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "RestReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/banknoteturnoverreport",
    name: "banknoteturnoverreport",
    component: () => import("@/views/report/banknoteturnoverreport/index.vue"),
    meta: {
      pageTitle: "BanknoteTurnoverReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "BanknoteTurnoverReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/bookdailyapprovement",
    name: "bookdailyapprovement",
    component: () => import("@/views/report/bookdailyapprovement/index.vue"),
    meta: {
      pageTitle: "BookDailyApprovement",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "BookDailyApprovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/bookdailyapprovement/view/id=:id",
    name: "ViewBookDailyApprovement",
    component: () => import("@/views/report/bookdailyapprovement/view.vue"),
    meta: {
      pageTitle: "BookDailyApprovement",
      navActiveLink: "bookdailyapprovement",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "BookDailyApprovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/absofflinereport",
    name: "absofflinereport",
    component: () => import("@/views/report/absofflinereport/index.vue"),
    meta: {
      pageTitle: "AbsOfflineReport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AbsOfflineReport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/absofflinereport/outbox/view/id=:id",
    name: "ViewAbsOfflineReportOutbox",
    component: () =>
      import("@/views/report/absofflinereport/outboxview.vue"),
    meta: {
      pageTitle: "AbsOfflineReportOutbox",
      navActiveLink: "absofflinereport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AbsOfflineReportOutbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/absofflinereport/present/view/id=:id",
    name: "ViewAbsOfflineReportPresent",
    component: () =>
      import("@/views/report/absofflinereport/presentview.vue"),
    meta: {
      pageTitle: "AbsOfflineReportPresent",
      navActiveLink: "absofflinereport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AbsOfflineReportPresent",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/absofflinereport/balance/view/id=:id",
    name: "ViewAbsOfflineReportBalance",
    component: () =>
      import("@/views/report/absofflinereport/balanceview.vue"),
    meta: {
      pageTitle: "AbsOfflineReportBalance",
      navActiveLink: "absofflinereport",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "AbsOfflineReportBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form141v",
    name: "form141v",
    component: () => import("@/views/report/form141v/index.vue"),
    meta: {
      pageTitle: "Form141V",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form141V",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/form17",
    name: "form17",
    component: () => import("@/views/report/form17/index.vue"),
    meta: {
      pageTitle: "Form17",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Form17",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/databasereplications",
    name: "databasereplications",
    component: () => import("@/views/report/databasereplications/index.vue"),
    meta: {
      pageTitle: "databasereplications",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "databasereplications",
          active: true,
        },
      ],
    },
  },
]
